import { Component, DestroyRef, effect, inject, input, linkedSignal, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HlmTabsImports } from '@spartan-ng/helm/tabs';
import { debounceTime, distinctUntilChanged } from 'rxjs';

import { Cartographie } from '../../../cartographie/models/cartographie.model';
import { DetailGeneralComponent } from './detail-general/detail-general.component';
import { DetailLivrablesComponent } from './detail-livrables/detail-livrables.component';
import { DetailObjectifsComponent } from './detail-objectifs/detail-objectifs.component';
import { ModuleDetailFormService } from './module-detail-form.service';
import { Référentiel } from '../../../administration/gestion-référentiels/models/référentiel.model';

const KEY_TAB_MODULE = 'module.tab';

@Component({
  selector: 'app-module-detail-contenu',
  imports: [DetailObjectifsComponent, DetailGeneralComponent, DetailLivrablesComponent, HlmTabsImports],
  templateUrl: './module-detail-contenu.component.html',
})
export class ModuleDetailContenuComponent implements OnInit {
  readonly detailFormService = inject(ModuleDetailFormService);
  readonly #destroyRef = inject(DestroyRef);

  readonly cartographie = input.required<Cartographie>();
  readonly referentiel = input.required<Référentiel>();
  readonly peutModifier = input.required<boolean>();

  readonly traductions = linkedSignal(() => this.referentiel().metadonnees.traductions);
  readonly activeTab = signal(sessionStorage.getItem(KEY_TAB_MODULE) ?? 'general');

  form = this.detailFormService.form;

  constructor() {
    effect(() => {
      if (!this.peutModifier()) {
        this.form.disable({ emitEvent: false });
      } else {
        this.form.enable({ emitEvent: false });
      }
    });
  }

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(distinctUntilChanged(), takeUntilDestroyed(this.#destroyRef), debounceTime(1000))
      .subscribe(() => this.detailFormService.submitModule());
  }

  tabActivated(tab: string) {
    sessionStorage.setItem(KEY_TAB_MODULE, tab);
    this.activeTab.set(tab);
  }
}
